module.exports = __webpack_public_path__ + "img/logo-cp-white.4cb4daba.svg";